import React from "react";
import Hero from './DroneBuilding/Hero';
import MagicBento from './DroneBuilding/MagicBento';
import CertificationMumbaiChandigarh from "./CertificationMumbaiChandigarh";
import WhoCanApply from "./WhoCanApply";

const DroneBuilding = () => {

  return (
    <>
      <Hero />
      <WhoCanApply />
      <MagicBento />
      <CertificationMumbaiChandigarh />
    </>
  );
};

export default DroneBuilding;
